import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=1ab470ec&scoped=true"
import script from "./GeneralSummary.vue?vue&type=script&lang=js"
export * from "./GeneralSummary.vue?vue&type=script&lang=js"
import style0 from "./GeneralSummary.vue?vue&type=style&index=0&id=1ab470ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab470ec",
  null
  
)

export default component.exports